import { FormControlLabel, styled, SwitchProps, Switch } from "@mui/material";
import { MasterDataContext } from "contexts/MasterDataContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark" ? "#2ECA45" : "rgb(67 207 102)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
interface ISwitchProps {
  checked?: boolean;
  setChecked(checked: boolean): void;
  "data-test"?: string;
}
function CustomSwitch({ checked, setChecked, ...rest }: ISwitchProps) {
  const { logEvent } = useContext(MasterDataContext);
  const { t } = useTranslation();
  const changeHandler = () => {
    setChecked(!checked);
    if (!checked) logEvent("EnableAllGradeMode");
    else logEvent("DisableAllGradeMode");
  };
  return (
    <FormControlLabel
      control={
        <IOSSwitch
          sx={{ m: 1 }}
          checked={checked === undefined ? false : checked}
          onChange={changeHandler}
        />
      }
      label={t("assign from other grades")}
      labelPlacement="start"
      sx={{ margin: 0 }}
      {...rest}
    />
  );
}

export default CustomSwitch;
